import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { projects } from "../data/projects";
import { ProjectCard } from "./ProjectCard";
import { SectionHeading } from "./SectionHeading";

export function ProjectsSection() {
  return (
    <section id="projects" className="section shell">
      <div className="section-heading-row">
        <SectionHeading
          number="02"
          eyebrow="Selected work / engineering stories"
          title="Built, tested, and still evolving."
          description="Each project starts with a real constraint—not a technology list."
        />
        <Link className="text-link section-link" to="/projects">View project archive <ArrowRight aria-hidden="true" /></Link>
      </div>
      <div className="project-grid">
        {projects.map((project, index) => <ProjectCard key={project.slug} project={project} index={index} />)}
      </div>
    </section>
  );
}
